import React from 'react';
import cl from './NotFound.module.css'

import notFoundImg from '../../assets/images/404_img.png'
import {NavLink} from "react-router-dom";

const NotFoundPage = () => {
    return (
        <div className={cl.main_not_found_page}>
            <div className={cl.img_wrapper}>
                <img src={notFoundImg} alt="#not found"/>
            </div>
            <h1 className={cl.not_found_title}>This page couldn’t be found</h1>
            <NavLink className={cl.navlink_home} to='/'>Go to Home page</NavLink>
        </div>
    );
};

export default NotFoundPage;